export default __webpack_public_path__ + "static/media/blueHole1.45379b05.webp";